const isPresent = value => !!value && value.trim() !== '';

// A DNS name of two or more labels: no scheme, port, path, credentials or whitespace.
const DNS_NAME = /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)+$/;

// The host part of a generateUrl base, which is either a bare host ("gg.tgm.cloud") or a host
// followed by a path ("gg.tgm.cloud/tgm-api/articles/...", as the API hands article URLs back).
const hostOf = base => base.split(/[/?#]/)[0].toLowerCase();

const config = {
    urlGgCloud: process.env.REACT_APP_HOST_GG_TGM_CLOUD,
    urlAccessCloud: process.env.REACT_APP_HOST_ACCESS_TGM_CLOUD,
    urlUkCloud: process.env.REACT_APP_HOST_UK_TGM_CLOUD,
    urlProtocol: process.env.REACT_APP_URL_PROTOCOL,

    recaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
    recaptchaEnabled: process.env.REACT_APP_RECAPTCHA_ENABLED,

    sentryDsn: process.env.REACT_APP_SENTRY_DSN,
    sentryEnabled: process.env.REACT_APP_SENTRY_ENABLED,

    fcmSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID,
    fcmEnabled: process.env.REACT_APP_FIREBASE_ENABLED,

    marketingHelpUrl: process.env.REACT_APP_MARKETING_HELP_URL,
    marketingJoinUrl: process.env.REACT_APP_MARKETING_JOIN_URL,

    // Public site with /policy-notice.json; the default keeps staging, whose .env is written
    // by Jenkins, showing the banner too.
    privacyUrl: process.env.REACT_APP_PRIVACY_URL || 'https://privacy.tgmpanel.com',

    gaTrackingId: process.env.REACT_APP_GA_TRACKING_ID,
    gaEnabled: process.env.REACT_APP_GA_ENABLED,

    metaPixelId: process.env.REACT_APP_META_PIXEL_ID,

    // Whether `base` points at a TGM API host: one of the configured hosts, or a subdomain of
    // their parent domain — the panels list names ~140 country hosts (pl.tgm.cloud,
    // us-panel.link.tgmsandbox.com on staging) that no configuration enumerates. Every request
    // built by generateUrl may carry the session's Bearer token or the login password, and the
    // `panel` cookie that picks the host can be planted from a sibling subdomain or over plain
    // HTTP, so any other host is refused (SE-PANEL-HOST-TOKEN).
    isTrustedApiHost: function(base) {
        if (typeof base !== 'string' || !isPresent(base)) return false;
        const host = hostOf(base);
        const configured = [this.urlGgCloud, this.urlAccessCloud, this.urlUkCloud]
            .filter(h => typeof h === 'string' && isPresent(h))
            .map(hostOf);
        // A build that configures no API host has no allowlist to derive (and cannot reach the
        // panels list or log anyone in), so the check only applies once a host is configured.
        if (configured.length === 0 || configured.includes(host)) return true;
        if (!DNS_NAME.test(host)) return false;
        return configured.some(h => {
            const parent = h.split('.').slice(1).join('.');
            // A configured "tgm.cloud" has the parent "cloud": never trust a whole TLD.
            return parent.includes('.') && host.endsWith(`.${parent}`);
        });
    },

    generateUrl: function(base) {
        if (!isPresent(this.urlProtocol) || !isPresent(base)) throw new Error('config.generateUrl: missing urlProtocol or base');
        if (!this.isTrustedApiHost(base)) throw new Error('config.generateUrl: not a TGM API host');
        return `${this.urlProtocol}://${base}`;
    },

    isSentryEnabled: function() {
        return isPresent(this.sentryDsn) && (process.env.NODE_ENV === 'production' || this.sentryEnabled === 'true');
    },

    isFcmEnabled: function() {
        return isPresent(this.fcmSenderId) && (process.env.NODE_ENV === 'production' || this.fcmEnabled === 'true');
    },

    isGaEnabled: function() {
        return isPresent(this.gaTrackingId) && (process.env.NODE_ENV === 'production' || this.gaEnabled === 'true');
    },

    isRecaptchaEnabled: function() {
        return isPresent(this.recaptchaSiteKey) && this.recaptchaEnabled !== 'false';
    }
}

export default config;
